import React from 'react';
import $ from 'jquery';
import './style.scss';

const ModalExtraRegister = ({ name }) => {
  const cancel = (e) => {
    e.preventDefault();
    $('#modal-extra-register')
      .removeClass('show')
      .css('display', 'none')
      .attr('aria-hidden', true);
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  };
  const handleLogin = (e) => {
    $('#modal-extra-register')
      .removeClass('show')
      .css('display', 'none')
      .attr('aria-hidden', true);
    $('#modal-extra-register-iframe').addClass('show').css('display', 'block');
  };
  return (
    <div className='modal fade modal-extra-register' id='modal-extra-register'>
      <div className='modal-dialog modal-dialog-centered' role='document'>
        <div className='modal-content'>
          <div className='modal-extra-register-content'>
            <h5 className='text-danger text-center'>
              Đăng ký sử dụng nền tảng thành công!
            </h5>
            <span className='text-center'>
              {name} muốn biết thêm thông tin của bạn để hỗ trợ tốt hơn, bạn có
              vui lòng gửi thêm thông tin cho {name}?
            </span>
            <div className='modal-extra-register-action'>
              <button
                type='submit'
                className='btn_cancel flex-center'
                onClick={cancel}
              >
                Bỏ qua
              </button>
              <button
                type='submit'
                className='btn_submit flex-center'
                onClick={handleLogin}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalExtraRegister;
